module.exports = __webpack_public_path__ + "img/tree-07-d-leaves.6a87b535.png";